import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { useMemo } from 'react';
echarts.use([PieChart]);

export type ChartType = 'applications' | 'shortlist' | 'rejected';

export type ChartData = Record<ChartType, number[]>;

export const colors: Record<ChartType, string> = {
  applications: '#AC5DDA',
  rejected: '#FDA32D',
  shortlist: '#00CEDE'
};

type Props = {
  data: ChartData;
  labels: string[];
};

const RecruiterAnalysisChart = ({ data, labels }: Props) => {
  const getSeries = (data: number[], type: ChartType) => {
    return {
      data,
      type: 'line',
      smooth: true,
      symbol: 'none',
      lineStyle: {
        width: 3,
        color: colors[type]
      }
    };
  };

  const options = useMemo(() => {
    const series = Object.entries(data).map(item =>
      getSeries(item[1], item[0] as ChartType)
    );
    return {
      xAxis: {
        type: 'category',
        data: labels
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false
        }
      },
      series
    };
  }, [data, labels]);

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={options}
      style={{ minHeight: '320px', width: '100%' }}
    />
  );
};

export default RecruiterAnalysisChart;
